/* SIFI BEAUVOIS — Vitrines accueil — reveal partagé (singleton window.SifiHomeReveal,
   IntersectionObserver, compatible éditeur via shopify:section:load). */
  (() => {
    const SELECTOR = '[data-sb-reveal]';

    const showImmediately = (elements) => {
      elements.forEach((element) => {
        element.classList.add('is-visible');
        element.dataset.sbRevealReady = 'true';
      });
    };

    const collectNewElements = (root = document) => {
      const elements = [];

      if (
        root instanceof Element &&
        root.matches(SELECTOR) &&
        !root.dataset.sbRevealReady
      ) {
        elements.push(root);
      }

      root.querySelectorAll?.(`${SELECTOR}:not([data-sb-reveal-ready])`)
        .forEach((element) => elements.push(element));

      return elements;
    };

    if (!window.SifiHomeReveal) {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const canObserve = !reduceMotion && 'IntersectionObserver' in window;

      const onIntersect = (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      };

      const observer = canObserve
        ? new IntersectionObserver(onIntersect, {
            threshold: 0.18,
            rootMargin: '0px 0px -8% 0px'
          })
        : null;

      /* Correctif 26/07 — vitrines « image de fond » (config ②) : leur contenu
         est ancré au bord BAS de l'écran. La zone morte de -8 % ci-dessus
         (pensée pour du contenu haut placé, config ①) peut exclure
         définitivement les éléments du bas sur les écrans hauts : jamais 18 %
         visibles hors zone morte -> opacity 0 à vie, mais toujours cliquables
         (symptôme constaté par Naji sur le lien). Observateur dédié SANS zone
         morte pour tout élément de ces vitrines. */
      const edgeObserver = canObserve
        ? new IntersectionObserver(onIntersect, { threshold: 0.18 })
        : null;

      window.SifiHomeReveal = {
        init(root = document) {
          const elements = collectNewElements(root);

          if (!elements.length) return;

          if (!observer) {
            showImmediately(elements);
            return;
          }

          elements.forEach((element) => {
            element.dataset.sbRevealReady = 'true';

            if (edgeObserver && element.closest('.sb-home-feature--bg-image')) {
              edgeObserver.observe(element);
              return;
            }

            observer.observe(element);
          });
        }
      };

      document.addEventListener('shopify:section:load', (event) => {
        window.SifiHomeReveal.init(event.target);
      });
    }

    const initCurrentDocument = () => {
      window.SifiHomeReveal.init(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCurrentDocument, {
        once: true
      });
    } else {
      initCurrentDocument();
    }
  })();

/* SIFI BEAUVOIS — Vitrines accueil — défilement par écran (une impulsion = une
   vitrine, glisse animée, impossible de s'arrêter entre deux). Actif uniquement
   quand le liquid pose la classe .sb-home-snap (page d'accueil). L'empilement
   visuel (sticky) vit dans homepage.css ; ici on n'orchestre QUE la position de
   défilement.
   ARCHITECTURE FINALE (26/07 au soir, type Miu Miu, validée après une journée
   d'essais) : le défilement vit dans le CONTENEUR INTERNE .sb-home-viewport
   (posé par theme.liquid sur le template index, document verrouillé par
   homepage.css). Le document ne défile jamais -> la barre d'adresse mobile ne
   bouge jamais -> les hauteurs dvh sont immobiles : la cause racine de tous
   les bugs de bas de page a disparu (les remèdes intermédiaires — gel des
   hauteurs, ombres, arrêts spéciaux maxScroll/cible relue/rentrée/tolérances,
   sticky ou dé-sticky du footer — ont été retirés, ne pas les retenter).
   LE FOOTER EST LA DERNIÈRE VITRINE DE LA PILE : son arrêt sort de la même
   accumulation que les autres, cadré sous le header (+1 px pour fondre son
   bord dans le trait du header). Garantie : footer >= un écran (min-height
   dans homepage.css) -> au-delà de son arrêt, son intérieur défile
   naturellement dans le conteneur. */
(() => {
  if (window.SifiHomeSnap) return;
  window.SifiHomeSnap = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  let boundaries = [];
  let animating = false;
  let quietUntil = 0;

  /* Conteneur de défilement interne (repli fenêtre si absent — la classe
     sb-home-snap n'existe que sur l'accueil, où theme.liquid pose le
     conteneur ; le repli ne sert qu'en cas d'usage inattendu). */
  let scroller = null;

  const scrollTop = () => (scroller ? scroller.scrollTop : window.scrollY);

  const scrollToY = (value) => {
    if (scroller) scroller.scrollTo(0, value);
    else window.scrollTo(0, value);
  };

  /* Panneau du header ouvert (menu mobile, vue pays/langue, tiroir
     pays/langue, méga-menu desktop, tiroir panier) : le moteur se met en
     retrait — correctif 26/07 (retour Naji : la page continuait à glisser
     sous les panneaux). Le verrou CSS du conteneur (homepage.css) empêche
     le défilement natif ; ce garde-fou empêche, lui, les glisses par
     programme, qui passeraient outre. Classes posées par header.liquid et
     cart.js. */
  const PANEL_CLASSES = [
    'sb-apple-menu-open',
    'sb-apple-region-view',
    'sb-lang-drawer-open',
    'sb-gw-drawer-open',
    'sifi-cart-is-open'
  ];

  const panelOpen = () =>
    PANEL_CLASSES.some((name) => document.body.classList.contains(name));

  const collectSections = () => {
    const seen = new Set();
    const sections = [];

    document.querySelectorAll('.sb-home-snap').forEach((shell) => {
      const section = shell.closest('.shopify-section');

      if (section && !seen.has(section)) {
        seen.add(section);
        sections.push(section);
      }
    });

    return sections;
  };

  /* Positions calculées par accumulation des hauteurs depuis le parent —
     jamais depuis les sections elles-mêmes : une section « collée » (sticky)
     rapporte sa position figée à l'écran, pas sa position dans le flux. */
  const computeBoundaries = () => {
    const sections = collectSections();

    if (sections.length < 2 || !sections[0].parentElement) {
      boundaries = [];
      return;
    }

    const parent = sections[0].parentElement;

    /* Dans le conteneur, les vitrines + footer sont ses enfants directs :
       l'accumulation démarre à 0. (Repli fenêtre : position du parent dans
       le document.) */
    const parentTop =
      parent === scroller
        ? 0
        : parent.getBoundingClientRect().top + scrollTop();

    /* Le footer est la dernière « vitrine » : même parent, même
       accumulation, même arrêt — cadré SOUS le header (à son arrêt le
       header est opaque, is-on-footer), +1 px pour glisser son bord sous
       le trait du header : une seule ligne grise au lieu de deux
       superposées à un cheveu (retour Naji 26/07, desktop et mobile). */
    const footer =
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer');
    const headerEl = document.querySelector('.sb-apple-header');
    const headerOffset = headerEl
      ? Math.round(headerEl.getBoundingClientRect().height)
      : 48;

    const result = [];
    let offset = 0;

    Array.from(parent.children).forEach((child) => {
      if (sections.includes(child)) {
        result.push(Math.round(parentTop + offset));
      } else if (child === footer) {
        result.push(Math.round(parentTop + offset - headerOffset + 1));
      }

      offset += child.offsetHeight;
    });

    boundaries = result.length > 1 ? result : [];
  };

  const zoneEnd = () => boundaries[boundaries.length - 1];

  const inZone = (y) =>
    boundaries.length > 1 && y >= boundaries[0] - 2 && y <= zoneEnd() + 2;

  const nearestIndex = (y) => {
    let best = 0;

    boundaries.forEach((b, i) => {
      if (Math.abs(y - b) < Math.abs(y - boundaries[best])) best = i;
    });

    return best;
  };

  /* Même famille de courbe que le réglage v16 du site. */
  const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - ((-2 * t + 2) ** 2) / 2);

  const glideTo = (index) => {
    const clamped = Math.max(0, Math.min(boundaries.length - 1, index));
    const target = boundaries[clamped];
    const from = scrollTop();

    if (Math.abs(target - from) < 2) return;

    animating = true;
    const start = performance.now();

    /* Les grandes glisses d'écran gardent leurs 700 ms validés ; les
       petites corrections du filet (quelques dizaines de px) sont brèves
       — rejouer 700 ms pour 20 px donnait un « double mouvement » senti
       comme un saut (retour Naji, footer mobile). */
    const span = Math.abs(target - from);
    const duration = span < 200 ? Math.max(240, Math.round(span * 1.2)) : 700;

    /* Cible FIGÉE au départ du geste — ne jamais la relire pendant
       l'animation : un « suivi en direct » a été essayé puis retiré le
       26/07 (« ça tremble, ça zoome, ça saute ») — chaque relecture bouge
       avec la barre d'adresse mobile, qui réagit au défilement, qui refait
       bouger la cible : boucle. Depuis, le footer est une vitrine comme
       les autres : arrêt d'accumulation, aucune cible mouvante. */
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);

      scrollToY(Math.round(from + (target - from) * ease(t)));

      if (t < 1) {
        requestAnimationFrame(step);
        return;
      }

      animating = false;
      quietUntil = performance.now() + 140;
    };

    requestAnimationFrame(step);
  };

  const onWheel = (event) => {
    if (panelOpen()) return;

    /* Début de geste (ni animation ni inertie en cours) : les repères
       sont recalculés — images qui chargent, éditeur... les hauteurs
       peuvent évoluer (la barre d'adresse, elle, ne bouge plus : le
       document ne défile jamais). */
    if (!animating && performance.now() >= quietUntil) computeBoundaries();

    const y = scrollTop();

    if (!inZone(y)) return;

    const direction = event.deltaY > 0 ? 1 : event.deltaY < 0 ? -1 : 0;

    if (!direction) return;

    const index = nearestIndex(y);

    /* Au dernier arrêt (footer), on rend la main : ce qui dépasse défile
       normalement. */
    if (direction > 0 && index === boundaries.length - 1) return;

    event.preventDefault();

    if (animating || performance.now() < quietUntil) {
      /* Avale l'inertie du trackpad : chaque cran résiduel prolonge le silence. */
      quietUntil = performance.now() + 120;
      return;
    }

    glideTo(index + direction);
  };

  let touchStartY = null;
  let touchCaptured = false;

  const onTouchStart = (event) => {
    if (panelOpen()) {
      touchStartY = null;
      return;
    }

    if (!animating) computeBoundaries();
    touchStartY = event.touches.length === 1 ? event.touches[0].clientY : null;
    touchCaptured = false;
  };

  const onTouchMove = (event) => {
    if (touchStartY === null) return;

    if (panelOpen()) {
      touchStartY = null;
      touchCaptured = false;
      return;
    }

    const y = scrollTop();

    if (!inZone(y)) {
      touchStartY = null;
      return;
    }

    /* iOS marque le touchmove non annulable quand le défilement natif a
       déjà commencé : impossible d'intercepter, on laisse faire — le
       filet (onScroll) ramènera sur la vitrine la plus proche. */
    if (!event.cancelable) {
      touchStartY = null;
      touchCaptured = false;
      return;
    }

    const delta = touchStartY - event.touches[0].clientY; /* > 0 = balayage vers le haut */
    const index = nearestIndex(y);

    /* Au dernier arrêt (footer), vers le bas : défilement natif. */
    if (delta > 0 && index === boundaries.length - 1) {
      touchStartY = null;
      return;
    }

    /* L'écran ne suit pas le doigt : c'est la glisse qui décide. */
    event.preventDefault();
    touchCaptured = true;
  };

  const onTouchEnd = (event) => {
    if (touchStartY === null || !touchCaptured) {
      touchStartY = null;
      return;
    }

    const delta = touchStartY - event.changedTouches[0].clientY;

    touchStartY = null;
    touchCaptured = false;

    if (animating || Math.abs(delta) < 24) return;

    glideTo(nearestIndex(scrollTop()) + (delta > 0 ? 1 : -1));
  };

  /* Filet : toute position laissée entre deux vitrines (barre de défilement,
     clavier, ancre, retour depuis le footer) est ramenée sur la plus proche. */
  let idleTimer = null;

  const onScroll = () => {
    if (animating) return;

    window.clearTimeout(idleTimer);

    idleTimer = window.setTimeout(() => {
      if (animating || panelOpen()) return;

      computeBoundaries();

      const y = scrollTop();

      if (!inZone(y)) return;

      const index = nearestIndex(y);

      if (Math.abs(y - boundaries[index]) > 4) glideTo(index);
    }, 180);
  };

  const startSnap = () => {
    scroller = document.querySelector('.sb-home-viewport');

    computeBoundaries();

    if (boundaries.length < 2) return;

    /* Molette/tactile : sur window (les événements remontent du conteneur).
       Défilement : sur le conteneur — le document, verrouillé, n'émet rien. */
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    (scroller || window).addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', computeBoundaries);
    window.addEventListener('load', computeBoundaries);
    document.addEventListener('shopify:section:load', computeBoundaries);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSnap, { once: true });
  } else {
    startSnap();
  }
})();

/* SIFI BEAUVOIS — Accueil — teinte du header selon le fond sous la barre
   (ajout 26/07/2026). Le header de l'accueil est transparent (header.css,
   variante sb-apple-header--home) : ce module pose is-on-dark quand la
   couche visible sous la barre (vitrine ou footer) a un fond sombre ->
   écritures/logo en blanc ; il l'enlève sur fond clair -> noir. Les
   tonalités sont relevées une fois (fond calculé, luminance 0-255,
   sombre < 128) puis, au défilement, la couche visible est le DERNIER
   élément du DOM couvrant le point sondé — même logique d'empilement
   que le sticky de homepage.css. Compatible éditeur (shopify:section:load). */
(() => {
  if (window.SifiHeaderTone) return;

  const header = document.querySelector('.sb-apple-header--home');

  if (!header) return;

  window.SifiHeaderTone = true;

  let zones = [];
  let frame = null;

  /* Luminance perçue (0-255) du fond calculé, ou null si transparent. */
  const brightnessOf = (element) => {
    if (!element) return null;

    const raw = window.getComputedStyle(element).backgroundColor || '';
    const parts = raw.match(/[\d.]+/g);

    if (!parts || parts.length < 3) return null;
    if (parts.length > 3 && parseFloat(parts[3]) < 0.5) return null;

    return (
      0.299 * parseFloat(parts[0]) +
      0.587 * parseFloat(parts[1]) +
      0.114 * parseFloat(parts[2])
    );
  };

  const collectZones = () => {
    const seen = new Set();

    zones = [];

    document.querySelectorAll('.sb-home-feature-shell').forEach((shell) => {
      const section = shell.closest('.shopify-section') || shell;

      if (seen.has(section)) return;
      seen.add(section);

      const brightness = brightnessOf(shell) ?? brightnessOf(section);

      zones.push({
        element: section,
        dark: brightness !== null && brightness < 128
      });
    });

    const footer =
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer');

    if (footer) {
      const brightness = brightnessOf(footer);

      zones.push({
        element: footer,
        dark: brightness !== null && brightness < 128,
        /* Au footer, le header redevient standard (voile blanc + trait) :
           classe is-on-footer posée dans applyTone — demande Naji 26/07. */
        isFooter: true
      });
    }
  };

  const applyTone = () => {
    frame = null;

    const headerRect = header.getBoundingClientRect();
    const probeY = (headerRect.height || 48) / 2;
    let dark = false;
    let onFooter = false;

    /* Dernier match = couche du dessus (ordre du DOM, comme le sticky). */
    zones.forEach((zone) => {
      const rect = zone.element.getBoundingClientRect();

      if (rect.top <= probeY && rect.bottom > probeY) dark = zone.dark;
    });

    /* is-on-footer : dès que le HAUT du footer touche le bas du header —
       depuis le 26/07 au soir le footer se cadre SOUS le header (arrêt
       décalé de sa hauteur), la sonde à mi-header ne le croise donc plus. */
    for (let i = zones.length - 1; i >= 0; i -= 1) {
      if (zones[i].isFooter === true) {
        const rect = zones[i].element.getBoundingClientRect();

        onFooter =
          rect.top <= headerRect.bottom + 4 && rect.bottom > headerRect.bottom;
        break;
      }
    }

    /* Sur le bandeau opaque du footer, les écritures restent noires —
       sans ça, la vitrine sombre encore sous la sonde laisserait
       is-on-dark poser du blanc sur fond blanc. */
    if (onFooter) dark = false;

    header.classList.toggle('is-on-dark', dark);
    header.classList.toggle('is-on-footer', onFooter);
  };

  const requestTone = () => {
    if (frame === null) frame = window.requestAnimationFrame(applyTone);
  };

  const start = () => {
    collectZones();
    applyTone();
  };

  /* Le défilement vit dans le conteneur interne de l'accueil (le document
     est verrouillé et n'émet aucun événement scroll). */
  const toneScroller = document.querySelector('.sb-home-viewport');

  (toneScroller || window).addEventListener('scroll', requestTone, {
    passive: true
  });
  window.addEventListener('resize', requestTone);
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* SIFI BEAUVOIS — Accueil — indicateur de vitrines (26/07/2026, demande Naji
   d'après miumiu.com) : en bas d'écran, « Faites défiler pour explorer » sur
   la 1re vitrine, puis « N / TOTAL » avec le chiffre qui défile comme un
   compteur à rouleau. Un SEUL élément pour toute la page, créé ici (hors des
   sections, donc jamais dupliqué) et inséré à côté du conteneur de
   défilement. La vitrine courante est celle qui couvre le CENTRE de l'écran
   — les vitrines étant empilées en sticky, la couche du dessus est le
   dernier élément du DOM qui couvre le point sondé (même logique que le
   guetteur de teinte). L'indicateur prend LA COULEUR DU TEXTE de cette
   vitrine (--vitrine-text — MAJ 16/08/2026, note dans update()) et
   s'efface dès que le footer occupe l'écran.
   NB traduction : le libellé d'invite est en dur ici — à reprendre le jour
   de la version EN (liste des textes en dur : bilan de code). */
(() => {
  if (window.SifiHomeProgress) return;

  const scroller = document.querySelector('.sb-home-viewport');
  const shells = document.querySelectorAll('.sb-home-snap');

  if (!scroller || shells.length < 2) return;

  window.SifiHomeProgress = true;

  /* Libelle pose par le Liquid (theme.liquid, cle home.scroll_hint), repli FR. */
  const HINT = (scroller && scroller.getAttribute('data-txt-hint')) || 'Faites défiler pour explorer';

  /* Vitrines dans l'ordre du DOM + footer (pour savoir quand s'effacer). */
  const sections = [];
  const seen = new Set();

  shells.forEach((shell) => {
    const section = shell.closest('.shopify-section') || shell;

    if (!seen.has(section)) {
      seen.add(section);
      sections.push(section);
    }
  });

  const footer =
    document.querySelector('.shopify-section-group-footer-group') ||
    document.querySelector('footer');

  /* MAJ 16/08/2026 (bug vu par Naji) : ici vivaient brightnessOf/isDark,
     la copie locale de la mesure de luminance du FOND (backgroundColor
     calculé) qui basculait is-on-dark — le signal du HEADER, dont le
     guetteur garde sa propre copie plus haut. Sur une vitrine à IMAGE de
     fond, ce fond mesuré est la couleur d'attente, choisie pour piloter le
     header (claire quand le haut de la photo est clair) : l'indicateur
     restait noir alors que le texte du bas est blanc sur voile sombre —
     invisible. L'indicateur suit désormais la couleur du texte : update(). */

  /* --- Construction (une seule fois) --- */
  const root = document.createElement('div');
  root.className = 'sb-home-progress is-hint';
  root.setAttribute('aria-hidden', 'true');
  root.innerHTML =
    '<span class="sb-home-progress__labels">' +
    '<span class="sb-home-progress__hint"></span>' +
    '<span class="sb-home-progress__count">' +
    '<span class="sb-home-progress__roll"><span></span></span>' +
    '<span class="sb-home-progress__total"></span>' +
    '</span>' +
    '</span>' +
    '<span class="sb-home-progress__line"></span>';

  root.querySelector('.sb-home-progress__hint').textContent = HINT;
  root.querySelector('.sb-home-progress__total').textContent =
    '/ ' + sections.length;

  const roll = root.querySelector('.sb-home-progress__roll');

  roll.firstElementChild.textContent = '1';

  /* La gouttière de la scrollbar du scroller, pour le centrage : voir la
     note de .sb-home-progress dans homepage.css. Mesurée ici puis revérifiée
     à chaque update() ; on n'ÉCRIT la variable que si la valeur change —
     update() tourne à chaque frame de défilement, pas question d'y invalider
     le style en continu. */
  let gouttiere = -1;

  const syncGouttiere = () => {
    const g = scroller.offsetWidth - scroller.clientWidth;

    if (g !== gouttiere) {
      gouttiere = g;
      root.style.setProperty('--sb-home-progress-gouttiere', g + 'px');
    }
  };

  syncGouttiere();

  scroller.parentNode.insertBefore(root, scroller.nextSibling);

  /* --- Compteur à rouleau --- */
  let shown = 1;

  const setNumber = (value) => {
    if (value === shown) return;

    const direction = value > shown ? 1 : -1;
    const outgoing = roll.firstElementChild;
    const incoming = document.createElement('span');

    shown = value;
    incoming.textContent = String(value);
    incoming.style.transform =
      'translateY(' + (direction > 0 ? '100%' : '-100%') + ')';
    roll.appendChild(incoming);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        outgoing.style.transform =
          'translateY(' + (direction > 0 ? '-100%' : '100%') + ')';
        outgoing.style.opacity = '0';
        incoming.style.transform = 'translateY(0)';
      });
    });

    window.setTimeout(() => {
      if (outgoing.parentNode === roll && roll.children.length > 1) {
        outgoing.remove();
      }
    }, 520);
  };

  /* --- Mise à jour --- */
  let frame = null;
  let couleurPosee = '';

  const update = () => {
    frame = null;

    syncGouttiere();

    const probeY = window.innerHeight / 2;

    /* Dernier élément du DOM qui couvre le centre = couche visible. */
    let current = null;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      if (rect.top <= probeY && rect.bottom > probeY) current = section;
    });

    const onFooter =
      footer &&
      (() => {
        const rect = footer.getBoundingClientRect();

        return rect.top <= probeY && rect.bottom > probeY;
      })();

    if (!current || onFooter) {
      root.classList.add('is-hidden');
      return;
    }

    root.classList.remove('is-hidden');

    const index = sections.indexOf(current);

    /* La couleur = CELLE DU TEXTE de la vitrine courante (« la même couleur
       que le texte en bas » — Naji, 16/08/2026), lue sur la variable
       --vitrine-text que le Liquid pose sur chaque section. En inline pour
       garder la transition color .4s du CSS ; on n'écrit que si la valeur
       change — update() tourne à chaque frame de défilement. Vitrine sans
       variable : style.color vidé, repli sur le color: #1f1f1f du CSS —
       le MÊME repli que celui du texte des vitrines, var(--vitrine-text,
       #1f1f1f) : l'indicateur ne peut pas diverger du texte. */
    const texte = (
      window.getComputedStyle(current).getPropertyValue('--vitrine-text') || ''
    ).trim();

    if (texte !== couleurPosee) {
      couleurPosee = texte;
      root.style.color = texte;
    }

    root.classList.toggle('is-hint', index === 0);
    root.classList.toggle('is-count', index > 0);

    if (index > 0) setNumber(index + 1);
  };

  const requestUpdate = () => {
    if (frame === null) frame = window.requestAnimationFrame(update);
  };

  scroller.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('load', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);

  update();
})();